import { render } from "./JsonFieldEditor.vue?vue&type=template&id=79ff37fa"
import script from "./JsonFieldEditor.vue?vue&type=script&lang=js"
export * from "./JsonFieldEditor.vue?vue&type=script&lang=js"

import "./JsonFieldEditor.vue?vue&type=style&index=0&id=79ff37fa&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__